import { render } from "./categoryShowAll.vue?vue&type=template&id=6a983f10&scoped=true"
import script from "./categoryShowAll.vue?vue&type=script&lang=ts"
export * from "./categoryShowAll.vue?vue&type=script&lang=ts"

import "./categoryShowAll.vue?vue&type=style&index=0&id=6a983f10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a983f10"

export default script